<lib-ph-bhp-change-password [userData]="config.userData" (childData)="onSubmitSuccess($event)"></lib-ph-bhp-change-password>